var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-loader"},[(_vm.isLoading)?_c('span',{staticClass:"skeleton-loader"}):_c('img',_vm._b({attrs:{"src":_vm.src},on:{"click":_vm.onClick}},'img',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }